import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { SEARCH_SECTION } from "@/constants/testIds";

const CHIPS = [
  "الذكاء الاصطناعي",
  "التقنية المالية",
  "الطاقة المتجددة",
  "السعودية",
  "الإمارات",
  "مصر",
];

/**
 * Home global search — the platform's primary CTA. Sits directly under the
 * Hero. Restrained styling: single input line, Fursa Green primary button,
 * a small strip of suggestion chips underneath so the field never feels empty.
 */
export const SearchSection = () => {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const goTo = (q) => {
    const trimmed = (q ?? "").trim();
    navigate(trimmed ? `/opportunities?q=${encodeURIComponent(trimmed)}` : "/opportunities");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    goTo(query);
  };

  return (
    <section
      data-testid={SEARCH_SECTION.root}
      className="bg-surface-50"
    >
      <div className="mx-auto max-w-5xl px-4 pb-8 pt-2 sm:px-6 sm:pb-12 lg:px-8">
        <form
          role="search"
          onSubmit={handleSubmit}
          className="group relative"
        >
          <div className="relative flex items-stretch overflow-hidden rounded-xl border border-surface-200 bg-white shadow-card transition-all focus-within:border-fursa-500 focus-within:shadow-lift">
            <Search
              className="pointer-events-none absolute inset-y-0 end-4 my-auto h-5 w-5 text-ink-500 group-focus-within:text-fursa-600"
              strokeWidth={1.75}
              aria-hidden
            />
            <input
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              data-testid={SEARCH_SECTION.input}
              placeholder="ابحث عن فرصة، قطاع، أو دولة…"
              aria-label="بحث عن فرصة"
              className="h-14 w-full border-0 bg-transparent ps-4 pe-12 text-base text-ink-900 outline-none placeholder:text-ink-500/60 sm:h-16 sm:text-lg"
            />
            <button
              type="submit"
              data-testid={SEARCH_SECTION.button}
              className="inline-flex items-center gap-1.5 rounded-none bg-fursa-700 px-6 text-sm font-semibold text-white transition-colors hover:bg-fursa-800 sm:px-8 sm:text-base"
            >
              بحث
            </button>
          </div>
        </form>

        {/* Suggestion chips — help users start without typing */}
        <div className="mt-4 flex flex-wrap items-center gap-2 text-xs">
          <span className="text-ink-500">جرّب:</span>
          {CHIPS.map((chip) => (
            <button
              key={chip}
              type="button"
              onClick={() => goTo(chip)}
              className="rounded-full border border-surface-200 bg-white px-3 py-1 text-ink-700 transition-colors hover:border-fursa-300 hover:bg-fursa-50 hover:text-fursa-700"
            >
              {chip}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
